import type { RouteItem } from '@web/common/src/routes';
import { isDev } from '@web/common/src/utils/util';
import { lazy } from 'react';
import { vhkUrlPrefix } from './utils';

const NotFound = lazy(() =>
  import('@web/components/src/NotFound').then((module) => ({ default: module.NotFound }))
);

const Introduction = lazy(() => import('@/pages/KKC/credit/introduction'));
const OtherRoutes = lazy(() => import('@/pages/KKC/banks'));
const Credit = lazy(() => import('@/pages/KKC/credit'));
const Edda = lazy(() => import('@/pages/KKC/edda'));
const Repayment = lazy(() => import('@/pages/KKC/repayment'));
const MainLoading = lazy(() => import('@/pages/KKC/loading/MainLoading'));
const RepayEnterance = lazy(() => import('@/pages/KKC/loading/RepayEnterance'));
const BillMgmt = lazy(() => import('@/pages/KKC/billMgmt'));
const Coupon = lazy(() => import('@/pages/KKC/coupon'));
const MGM = lazy(() => import('@/pages/KKC/mgm'));
const VhkPub = lazy(() => import('@/pages/vhkPub'));

const Pub = lazy(() => import('@/pages/pub'));

const NavigateComp = lazy(() => import('@/pages/KKC/loading/NavigateComp'));

// CASH LOAN
const CLCredit = lazy(() => import('@/pages/CL/credit'));
const CLPub = lazy(() => import('@/pages/CL/clPub'));

// CreFIT Mobile Cash
const Cmc = lazy(() => import('@/pages/CMC'));

// Bill Management
const BillMgmtV2 = lazy(() => import('@/pages/BillMgmt'));

// web H5
const WebPub = lazy(() => import('@/pages/webPub'));
const VoicePlayerDemo = lazy(() => import('@/components/VoicePlayer/Demo'));
const CommonDialogDemo = lazy(
  () => import('@web/common/src/components/CommonDialog/CommonDialogDemo')
);

const PhoneVerifyDialogDemo = lazy(() => import('@/components/PhoneVerifyDialog/Demo'));

const routes: RouteItem[] = [
  {
    path: '',
    component: <Introduction />,
    meta: {
      name: '产品介绍页',
      nameLangKey: 'pageTitle.intro',
    },
  },
  {
    path: 'pub/*',
    component: <Pub />,
    meta: {
      name: '公共路由',
    },
  },
  {
    path: `${vhkUrlPrefix}/vhkPub/*`,
    component: <VhkPub />,
    meta: {
      name: '',
    },
  },
  {
    path: `${vhkUrlPrefix}/credit/*`,
    component: <Credit />,
    meta: {
      name: '',
    },
  },
  {
    path: `${vhkUrlPrefix}/edda/*`,
    component: <Edda />,
    meta: {
      name: 'eDDA管理',
    },
  },
  {
    path: `${vhkUrlPrefix}/repayment/*`,
    component: <Repayment />,
    meta: {
      name: '还款管理',
    },
  },
  {
    path: `${vhkUrlPrefix}/billMgmt/*`,
    component: <BillMgmt />,
    meta: {
      name: '账单管理',
    },
  },
  {
    path: `${vhkUrlPrefix}/mgm/*`,
    component: <MGM />,
    meta: {
      name: '邀請好友',
    },
  },
  {
    path: `${vhkUrlPrefix}/clCredit/*`,
    component: <CLCredit />,
    meta: {
      name: 'Cash Loan 授信',
    },
  },
  {
    path: `${vhkUrlPrefix}/cmc/*`,
    component: <Cmc />,
    meta: {
      name: '',
    },
  },
  {
    path: `${vhkUrlPrefix}/cl/*`,
    component: <CLPub />,
    meta: {
      name: 'Cash Loan 公共页',
    },
  },
  {
    path: `${vhkUrlPrefix}/coupon/*`,
    component: <Coupon />,
    meta: {
      name: 'Coupon 公共页',
    },
  },
  {
    path: `${vhkUrlPrefix}/webPub/*`,
    component: <WebPub />,
    meta: {
      name: '',
    },
  },
  {
    path: `${vhkUrlPrefix}/voiceDemo`,
    component: <VoicePlayerDemo />,
    meta: {
      name: '',
      nameLangKey: '',
    },
  },
  {
    path: 'loading',
    component: <MainLoading />,
    meta: {
      name: '',
      nameLangKey: '',
    },
  },
  {
    path: `${vhkUrlPrefix}/repayEnterance`,
    component: <RepayEnterance />,
    meta: {
      name: '',
      nameLangKey: '',
    },
  },
  {
    path: `${vhkUrlPrefix}/navigate`,
    component: <NavigateComp />,
    meta: {
      name: '',
      nameLangKey: '',
    },
  },
  {
    path: '404',
    component: <NotFound />,
    meta: {
      name: '404',
    },
  },
  {
    path: '*',
    component: <OtherRoutes />,
    meta: {
      name: '其他路由页面',
    },
  },
];

if (isDev()) {
  routes.push({
    path: `${vhkUrlPrefix}/billMgmtv2/*`,
    component: <BillMgmtV2 />,
    meta: {
      name: '账单管理',
    },
  });
  routes.push({
    path: `${vhkUrlPrefix}/dialogDemo/*`,
    component: <CommonDialogDemo />,
    meta: {
      name: 'Dialog 演示',
    },
  });

  routes.push({
    path: `${vhkUrlPrefix}/phoneVerifyDialogDemo/*`,
    component: <PhoneVerifyDialogDemo />,
    meta: {
      name: 'PhoneVerifyDialog 演示',
    },
  });
}

export default routes;
